<div class="link-landing">
  <div class="link-card">
    <img class="link-logo" src="assets/vericure-logo-cobalt.png" alt="Vericure" />

    <h1 class="link-title">{{ 'InviteTitle' | t }}</h1>

    <p class="link-message" *ngIf="view === 'checking' || view === 'working'">{{ messageKey | t }}</p>

    <ng-container *ngIf="view === 'invalid' || view === 'not-pending' || view === 'unavailable'">
      <p class="link-message link-message-warn">{{ messageKey | t }}</p>
    </ng-container>

    <ng-container *ngIf="view === 'sign-in'">

      <button
        *ngIf="model === 'byot-entra'"
        type="button"
        class="link-signin microsoft-login"
        (click)="signInWithMicrosoft()">
        <span class="icon btn-icon"><i class="fa-brands fa-windows"></i></span>{{ 'LoginSignInWithMicrosoft' | t }}
      </button>

      <button
        *ngIf="model === 'external'"
        type="button"
        class="link-signin"
        (click)="signInExternal()">{{ 'LinkSignInWithEmail' | t }}</button>
      <p class="link-hint" *ngIf="model === 'external'">{{ 'LinkExternalForgotHint' | t }}</p>

      <!-- Google Identity Services renders its own button into this host. -->
      <div #googleHost class="link-google-host" *ngIf="model === 'byot-google'"></div>
    </ng-container>

    <!-- Someone is ALREADY signed in: never assumed to be the invitee (Joel, 2026-10-08). -->
    <ng-container *ngIf="view === 'confirm'">
      <p class="link-message" data-test="confirm-account">{{ 'LinkConfirmAccount' | t: { who: signedInAs } }}</p>
      <button type="button" class="link-signin" data-test="accept-as" (click)="acceptAsSignedIn()">
        {{ 'LinkAcceptWithThisAccount' | t }}
      </button>
      <button type="button" class="link-signin link-signin-secondary" data-test="use-different" (click)="useDifferentAccount()">
        {{ 'LinkUseDifferentAccount' | t }}
      </button>
    </ng-container>

    <!-- An External invite already accepted: the way back in until /login has its own button. -->
    <ng-container *ngIf="view === 'returning'">
      <p class="link-message">{{ messageKey | t }}</p>
      <button type="button" class="link-signin" (click)="signInReturning()">{{ 'LinkSignInWithEmail' | t }}</button>
    </ng-container>

    <ng-container *ngIf="view === 'done'">
      <p class="link-message link-message-ok">{{ 'InviteDone' | t }}</p>
      <button type="button" class="link-signin" (click)="continueToApp()">{{ 'InviteContinue' | t }}</button>
    </ng-container>

    <ng-container *ngIf="view === 'error'">
      <!-- The server's message, verbatim, when it sent one. -->
      <p class="link-message link-message-warn" *ngIf="serverMessage">{{ serverMessage }}</p>
      <p class="link-message link-message-warn" *ngIf="!serverMessage">{{ messageKey | t }}</p>
      <!-- Which account the refusal was about, so "a different organisation" is not a riddle. -->
      <p class="link-message" *ngIf="wrongAccount && signedInAs" data-test="tried-account">
        {{ 'LinkTriedAccount' | t: { who: signedInAs } }}
      </p>
      <button *ngIf="wrongAccount" type="button" class="link-signin" data-test="use-different" (click)="useDifferentAccount()">
        {{ 'LinkUseDifferentAccount' | t }}
      </button>
    </ng-container>
  </div>
</div>
